import PublicContainer from './PublicContainer';

export default PublicContainer;
